var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-box"},[_c('Table',{attrs:{"tableTitle":_vm.tableTitle,"searchTime":false,"operation":"打印报告","searchUrl":_vm.url,"back":{},"form":_vm.form,"operation-list":_vm.operationList,"operation-left":false,"tableCheckbox":false},on:{"operation-click":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }